import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { TbPlugConnectedX } from "react-icons/tb";
import "./ErrorContainer.css";

export default function ErrorContainer() {
  return (
    <Container>
      <Row>
        <Col>
          <div className="error-container">
            <TbPlugConnectedX className="error-container-icon" />
            Houve um problema no carregamento dos dados
          </div>
        </Col>
      </Row>
    </Container>
  );
}
